import { QuickbookCard } from './QuickbookCard';

import { AppConfigType } from '../../AppList/AppList';

export const QUICKBOOKS: AppConfigType = {
  id: 'quickbooks',
  name: 'QuickBooks Online',
  shortName: 'QuickBooks',
  css: {
    image: 'url(/images/quickbooks-icon.png',
  },
  Card: QuickbookCard,
};
